import { css } from '@emotion/react'
import { mediaQuery, typo } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const S = {
  header: css`
    width: 100%;
    border-bottom: 1px solid ${colors.borderColor};
    position: relative;

    .header-container {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      max-width: 1920px;
      margin: 0 auto;
      padding: 0 24px;

      ${mediaQuery.medium} {
        width: 100%;
      }
    }
    .header-container-left,
    .header-container-right {
      display: flex;
      align-items: center;
      flex: 1;
    }

    .header-container-left {
      gap: 60px;
    }

    .header-container-right {
      height: 100%;
    }
    .header-school-exam-zone-badge {
      cursor: pointer;
      border: 1px solid var(--Colors-Orange-300);
      margin: 8px;

      &:hover {
        background-color: var(--Colors-Orange-200);
      }
      &.active {
        border-radius: 4px;
        border: 1px solid var(--Colors-Orange-400);
        background: var(--Colors-Orange-300);
        color: var(--Colors-Orange-600);
      }
    }
    .nav-link {
      display: flex;
      gap: 40px;
      height: 100%;
    }
  `,
}

export default S
